import React from 'react'
import "./CsrDetailsBanner.css"
import "./ResponsiveCsrDetailsBanner.css"
const host = process.env.REACT_APP_API_SERVER;
const CsrDetailsBanner = (CsrOneData) => {

    return (
        <>
            {/*  */}
            <section className='csr-banner-section' >
                <div className=" align-items-center">
                    <div className="text-start">
                        <div className="banner-top-img-bg-rel">
                            <img src={CsrOneData?.CsrOneData?.banner ? `${host}/${CsrOneData?.CsrOneData?.banner}` : ""} alt="" className='img-fluid banner-img-tag' />
                            {/* <div className="banner-top-content-absol business-heading text-start">
                                <img src="/images/help-and-support/heading-bg.png" alt="" className='img-fluid' />
                                <div className='business-banner-heading'>
                                    <div className="container">
                                        <h1>{CsrOneData?.CsrOneData?.title}</h1>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CsrDetailsBanner